import { evaluateSpeechAttempt, type SpeechAttemptFeedback } from "@mobile/speech/evaluateSpeech";

import type { WebSpeechResult } from "./webSpeech";

type EvaluateSpeechArguments = Parameters<typeof evaluateSpeechAttempt>;

export function evaluateBestWebSpeechAttempt(
  result: WebSpeechResult,
  expectedText: EvaluateSpeechArguments[1],
  speechEvaluation: EvaluateSpeechArguments[2],
  uiLanguage: EvaluateSpeechArguments[3],
  targetLanguage: EvaluateSpeechArguments[4],
): SpeechAttemptFeedback {
  const transcripts = [
    result.transcript,
    ...result.alternatives.map((alternative) => alternative.transcript),
  ].filter((transcript, index, values) => (
    transcript.trim().length > 0 && values.indexOf(transcript) === index
  ));

  let bestFeedback = evaluateSpeechAttempt(
    transcripts[0] || "",
    expectedText,
    speechEvaluation,
    uiLanguage,
    targetLanguage,
  );
  for (const transcript of transcripts.slice(1)) {
    const feedback = evaluateSpeechAttempt(
      transcript,
      expectedText,
      speechEvaluation,
      uiLanguage,
      targetLanguage,
    );
    if (feedback.score > bestFeedback.score) {
      bestFeedback = feedback;
    }
  }
  return bestFeedback;
}
